import { Button } from '@app/components/various/Button';
import { Popover } from '@app/components/various/Popover';
import { getIsPublishing } from '@app/ducks';
import { getIsAnyLanguagePublished } from '@app/logic/pages';
import { Cms } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { PublishLanguagesPopup } from './PublishLanguagesPopup';

interface Props {
  pageMeta: Cms.Page;
}

export const MultiLanguageButton = ({ pageMeta }: Props) => {
  const { t } = useTranslation(['cmsConfirmationConfig', 'cms', 'common']);

  const pageLanguages = pageMeta.languages ?? [];
  const isPublishing = useSelector(getIsPublishing);

  const publishButtonName = getIsAnyLanguagePublished(pageLanguages) ? t('common:update') : t('cms:publish');

  return (
    <Popover
      isClickable
      content={({ handleClose }) => <PublishLanguagesPopup closeMenu={handleClose} pageLanguages={pageLanguages} pageId={pageMeta.id} />}
      contentHeader={t('cms:languages_to_publish')}
      placement="bottom-end"
      className="min-w-80"
      possiblePlacements={['bottom-start', 'bottom-end', 'top-start', 'top-end']}
    >
      {({ isVisible }) => (
        <Button isLoading={isPublishing} isChevronOpen={isVisible}>
          {publishButtonName}
        </Button>
      )}
    </Popover>
  );
};
